import React, { Component } from 'react'
import {DropdownButton, MenuItem, ButtonGroup} from 'react-bootstrap'
import Button from '../../../../../components/Buttons'
import SearchAutocomplete from '../SearchAutoComplete/SearchAutocomplete.container'
import PanelOptions from '../PanelOptions/panelOptions'
import { translate } from 'react-translate'

@translate('SearchBar')
class SearchResponsive extends Component {
  render(){

    const {
      clicked,
      open,
      onOpenOptions,
      onClickOperation,
      operation,
      property_type,
      property_types,
      property_types_loading,
      sub_property_type,
      onSelectPropertyType,
      t,
      operation_types
    } = this.props

    let title = !open ? 'más opciones' : 'menos opciones'
    let titleClassButton = !open ? 'btn-primary btn-submit' : 'button-active'
    var placeholderPropertyType = ''
    if (property_types && property_types.length === 1) {
      placeholderPropertyType = property_types[0].name
    } else {
      placeholderPropertyType = t('Tipo_de_Propiedad')
    }
    var titleType = ''
    var isIncluded = []
    if(sub_property_type) isIncluded = property_types.filter(item => item.id == sub_property_type.id)
    if( sub_property_type && !property_type.length && sub_property_type.is_sector == 0 && isIncluded.length ) {
      titleType = sub_property_type.name
    } else if(property_type.length) {
      titleType = property_type[0].name
    }
    else titleType = placeholderPropertyType

    let titleOperation = (operation.length !== 0 && operation[0].name)
      ? t(operation[0].name.replace(' ','_'))
      : t('Venta')

    return(
      <div className='col-md-12'>
        <div className='row upper-selectors'>
          <div className='col-xs-6'>
            <DropdownButton
              title={titleOperation}
              className='dropdown-basic-type searchbar-operations-type-selector'
              onSelect={ onClickOperation }
            >
              {operation_types && operation_types.length && operation_types.map((item) =>
                <MenuItem eventKey={item} key={item.id}>{t(item.name.replace(' ','_'))}</MenuItem>
              )}
            </DropdownButton>
          </div>
          <div className='col-xs-6'>
            {(property_types_loading)?
              (<DropdownButton
                className={'dropdown-basic-type'}
                autosize={false}
                multi={true}
                disabled={true}
                clearable={false}
                value={'cargando...'}
                placeholder={'Cargando...'}
                title={'Cargando...'}
                options={[]}
              />)
            : (!!property_types && !!property_types.length &&
            <DropdownButton
              title={titleType} className='dropdown-basic-type dropdown-responsive' onSelect={ onSelectPropertyType }
            >
              {property_types.map((item) =>
                <MenuItem className='div-option' eventKey={item} key={item.id}>{item.name}</MenuItem>
              )}
            </DropdownButton>)
            }
          </div>
        </div>
        <ButtonGroup className='search-bar'>
          <SearchAutocomplete />
          <Button type='submit' classes='btn-primary btn-search' id='btn-search' clickButton={clicked}>
            <i className='fa fa-search' aria-hidden='true'></i>
          </Button>
        </ButtonGroup>
        <div className='submit'>
          <Button type='submit' classes={titleClassButton} text={title} clickButton={onOpenOptions} />
        </div>
        <PanelOptions open={open} />
      </div>
    )
  }
  _renderTypes() {
    return (
      <div className='dropdown-types'>
        <MenuItem header>Residencial</MenuItem>
        <MenuItem>Casa</MenuItem>
        <MenuItem>Casa Barrio Cerrado</MenuItem>
        <MenuItem>Departamento</MenuItem>
        <MenuItem>Piso</MenuItem>
        <MenuItem>Semi Piso</MenuItem>
        <MenuItem>Ph</MenuItem>
        <MenuItem>Duplex</MenuItem>
        <MenuItem>Triplex</MenuItem>
        <MenuItem header>Oficinas</MenuItem>
        <MenuItem>Edificios</MenuItem>
        <MenuItem className='div-option'>Locales</MenuItem>
        <MenuItem className='div-option'>Industrias</MenuItem>
        {/* HIDE-HOTELS <MenuItem className='div-option'>Hoteles</MenuItem> */}
        <MenuItem className='div-option'>Campos</MenuItem>
        <MenuItem className='div-option'>Emprendimientos</MenuItem>
        <MenuItem className='div-option'>Terrenos</MenuItem>
      </div>
    )
  }
}

export default SearchResponsive



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/SearchResponsive/searchResponsive.js